'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports['default'] = CurrentOpenings;

require('./index.scss');

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function CurrentOpenings(props) {
    return _react2['default'].createElement(
        'div',
        { className: 'm-careers-page--current-openings' },
        _react2['default'].createElement(
            'h2',
            null,
            _react2['default'].createElement(
                'span',
                null,
                'CURRENT OPENINGS'
            )
        ),
        _react2['default'].createElement(DepartmentsListings, { departments: props.departments }),
        _react2['default'].createElement(ViewAllButton, { jobsUrl: props.jobsUrl })
    );
}

function DepartmentsListings(props) {
    var departments = cleanDepartmentData(props.departments);
    return _react2['default'].createElement(
        'div',
        { className: 'm-careers-page--departments row' },
        departments.map(renderDepartment)
    );
}

function cleanDepartmentData(departmentsObject) {
    return Object.values(departmentsObject).filter(function (department) {
        return !!department.jobs.length;
    });
}
function renderDepartment(department, i, array) {
    var props = {
        department: department,
        key: i,
        isBorderRight: !!((i + 1) % 3), // This allows us to add border except on edge of row
        isLast: i >= array.length - 1 // determins the last element of collection
    };
    return _react2['default'].createElement(Department, props);
}

function Department(props) {
    var _props$department = props.department,
        name = _props$department.name,
        jobs = _props$department.jobs;

    var className = (0, _classnames2['default'])({
        'm-careers-page--department': true,
        'columns': true,
        'small-12': true,
        'medium-4': true,
        'large-4': true,
        'border-right': props.isBorderRight,
        'end': props.isLast
    });
    return _react2['default'].createElement(
        'div',
        { className: className },
        _react2['default'].createElement(
            'h3',
            null,
            name
        ),
        jobs.map(function (job, i) {
            return _react2['default'].createElement(Job, { job: job, key: i });
        })
    );
}

function Job(props) {
    var _props$job = props.job,
        absolute_url = _props$job.absolute_url,
        title = _props$job.title;

    var linkProps = {
        href: absolute_url,
        className: 'm-careers-page--department--job-listing'
    };
    return _react2['default'].createElement(
        'a',
        linkProps,
        title
    );
}

function ViewAllButton(props) {
    var jobsUrl = props.jobsUrl;
    var buttonClassName = (0, _classnames2['default'])({
        'm-button': true,
        'm-careers-page--current-opening--button': true,
        'bg-cerulean': true,
        'hbg-castle-rock': true,
        'c-white': true,
        'hc-white': true
    });

    return _react2['default'].createElement(
        'div',
        { className: 'm-careers-page--current-openings--view-all' },
        _react2['default'].createElement(
            'a',
            { href: jobsUrl, className: buttonClassName, target: '_blank', rel: 'noopener noreferrer' },
            'View All'
        )
    );
}


/*****************
 ** WEBPACK FOOTER
 ** ./src/landing-pages/components/careers-page/current-openings/index.jsx
 ** module id = 1558
 ** module chunks = 0
 **/